<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
 
      
      <el-form-item label="试题" prop="examId">
		    <span style="padding-right:10px;" :key="g" v-for="g in this.examNameList">{{g}}</span>
        <el-button style="color: #0aa0bf" @click="getExamList()">+添加试题</el-button>
      </el-form-item>
 

      <el-form-item label="排序" prop="sort">
        <el-input v-model="dataForm.sort" placeholder="排序"  type="number"></el-input>
      </el-form-item>
       
 
      <el-form-item label="备注" prop="remark">
        <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>

	<choose-exam v-if="chooseExamVisible" ref="chooseExam" v-on:checkedExam="checkedExam"></choose-exam>

  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import ChooseExam from './choose-exam'
export default {
  data () {
    return {
      visible: false,
	  chooseExamVisible: false,
	  examNameList: [],
      dataForm: {
        id: '',
        paperId: '',
        examId: '',
        sort: '',
        schoolId: '',
        creator: '',
        updater: '',
        createDate: '',
        updateDate: '',
        remark: '',
		examList: [],
      }
    }
  },
  computed: {
    dataRule () {
      return {
		 examId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
		 paperId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],

      }

    }
  },
  methods: {
    init () {
      this.visible = true
	  this.dataForm.examId=''
	   this.dataForm.examList=[]
	   this.examNameList =[]
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    getExamList () {
      this.chooseExamVisible = true
      this.$nextTick(() => {
        this.$refs.chooseExam.init()
      })
    },
	 // 选中的考试
    checkedExam(val) {
		this.dataForm.examId= val[0][0]
       this.dataForm.examList = val[0]
      this.examNameList = val[1]
    },

    // 获取信息
    getInfo () {
      this.$http.get('/parentStarLicense/jzpaperexam/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }

	   this.dataForm.examList.push(this.dataForm.examId);
	   this.examNameList.push(this.dataForm.examTitle);


      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/parentStarLicense/jzpaperexam/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  },
    components: {
    ChooseExam
  }
}
</script>
